import {
  PAYMENT_CATEGORY,
  PAYMENT_TYPE,
  STRIPE_PAYMENT_TYPE,
} from '../constants';
import { apiCall, doNothing } from '../util';
import { stripeGetApi, stripeGetApiText } from '../utils/stripeApi';
import {
  STRIPE_KEY_ATTEMPT,
  STRIPE_KEY_FAILED,
  STRIPE_KEY_LOADED,
  STRIPE_PAYMENT_METHOD_ATTEMPT,
  STRIPE_PAYMENT_METHOD_FAILED,
  STRIPE_PAYMENT_METHOD_LOADED,
  STRIPE_PAYMENT_METHOD_RESET,
  STRIPE_PAYMENT_METHOD_SAVED,
  STRIPE_PAYMENT_METHOD_SAVED_UNDID,
} from './types';

async function getStripePublishableKey() {
  const request = await stripeGetApiText('publishable-key');

  return request;
}

async function getSetupIntent({
  diamondClientId,
  email,
  name,
  origin,
  recaptchaToken,
}) {
  let clientSecret = null;

  try {
    const body = {
      post: {
        DiamondClientId: diamondClientId,
        email,
        name,
        origin,
        token: recaptchaToken,
      },
    };

    const request = await apiCall('purchase/payments/setup-intent', body);
    const response = await request.json();

    clientSecret = response?.clientSecret;
  } catch (_) {
    doNothing();
  }

  return clientSecret;
}

export function getStripeKeys({ origin, recaptchaToken }) {
  return async (dispatch, getState) => {
    try {
      const state = getState().quoting || {};
      const { stripeKey } = state.stripe;
      const { email, name } = state.newCustomer;

      const { nopCommerceUser: { DiamonClientdId } } = state.sessionInformation
        || { nopCommerceUser: 0 };

      dispatch({ type: STRIPE_KEY_ATTEMPT });

      const publicKey = stripeKey || await getStripePublishableKey();
      const clientSecret = await getSetupIntent({
        diamondClientId: DiamonClientdId,
        email,
        name,
        origin,
        recaptchaToken,
      });

      dispatch({
        data: { clientSecret, publicKey },
        type: STRIPE_KEY_LOADED,
      });
    } catch (error) {
      dispatch({ error: error.message, type: STRIPE_KEY_FAILED });
    }
  };
}

export function setStripePaymentMethod({ clientSecret, id, token }) {
  return {
    data: { clientSecret, id, token },
    type: STRIPE_PAYMENT_METHOD_LOADED,
  };
}

export function setStripePaymentMethodError(error) {
  return { error, type: STRIPE_PAYMENT_METHOD_FAILED };
}

export function setStripePaymentReset() {
  return { type: STRIPE_PAYMENT_METHOD_RESET };
}

export function stripePaymentAttempt() {
  return { type: STRIPE_PAYMENT_METHOD_ATTEMPT };
}

export function decodeStripeToken(token) {
  return async (dispatch) => {
    try {
      const url = `payment-methods?paymentMethodId=${token}`;
      const response = await stripeGetApi(url);

      if (!response.ok) {
        return;
      }

      const { data } = response;

      const expirationDate = data.expiresOn
        ? data.expiresOn.split('T')[0].split('-')
        : ['', ''];

      const paymentMethod = {
        accountType: data.accountType,
        cardExpirationMonth: expirationDate[1],
        cardExpirationYear: expirationDate[0],
        cardType: data.cardType,
        lastFourDigits: data.last4,
        paymentCategory: data.paymentType === STRIPE_PAYMENT_TYPE.creditCard
          ? PAYMENT_CATEGORY.creditCard
          : PAYMENT_CATEGORY.bankAccount,
        paymentMethodType: data.paymentType === STRIPE_PAYMENT_TYPE.creditCard
          ? PAYMENT_TYPE.creditCard
          : PAYMENT_TYPE.bank,
        paymentType: data.paymentType,
        token,
      };

      dispatch({
        customerUpdated: true,
        paymentMethod,
        type: STRIPE_PAYMENT_METHOD_SAVED,
      });
    } catch (_) {
      doNothing();
    }
  };
}

export function updatePaymentMethod({
  lastFourDigits,
  paymentCategory,
  token,
}) {
  return {
    paymentMethod: {
      accountType: '',
      cardExpirationMonth: '',
      cardExpirationYear: '',
      cardType: '',
      lastFourDigits,
      paymentCategory,
      paymentMethodType: paymentCategory === PAYMENT_CATEGORY.creditCard
        ? PAYMENT_TYPE.creditCard
        : PAYMENT_TYPE.bank,
      token,
    },
    type: STRIPE_PAYMENT_METHOD_SAVED,
  };
}

export function undoDefaultPaymentMethod(data) {
  return { data, type: STRIPE_PAYMENT_METHOD_SAVED_UNDID };
}
